import { call, put, takeLatest, select } from 'redux-saga/effects';
import { createStructuredSelector } from 'reselect';
import { SubmissionError } from 'redux-form';
import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
} from './constants';
import { makeSelectAccountType } from '../AccountTypeProvider/selectors';
import { CREATOR_ACCOUNT } from '../AccountTypeProvider/constants';
import * as authService from '~/services/auth';

function* forgotPassword(params) {
  const { resolve, reject, email, currentLanguage } = params;
  // const accountTypeSelector = yield select(
  //   createStructuredSelector({
  //     accountType: makeSelectAccountType(),
  //   }),
  // );
  try {
    yield call(authService.forgotPassword, {
      email,
      currentLanguage,
      accountType: CREATOR_ACCOUNT,
    });
    yield put({
      type: FORGOT_PASSWORD_SUCCESS,
      email,
    });

    resolve();
  } catch (error) {
    if (error.response.status === 422) {
      const message = error.response.data.message.emailExisted;
      if (message.emailNotExisted) {
        reject(
          new SubmissionError({
            email: 'Email does not exist',
          }),
        );
      }
    } else {
      yield put({ type: FORGOT_PASSWORD_ERROR, error });
      reject(error);
    }
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* forgotPasswordSaga() {
  yield takeLatest(FORGOT_PASSWORD, forgotPassword);
}
